import React, { useLayoutEffect } from "react";
import PropTypes from "prop-types";

import { useAuth } from "frontend/hooks/useAuth";

import LoadingSpinner from "core/LoadingSpinner";

const ProtectedRoute = ({ component: Component, ...props }) => {
    const { isLoggedIn, confirmAuth } = useAuth();

    // Because user objects are cached, we can immediately test if the user is logged in.
    useLayoutEffect(() => {
        if (!isLoggedIn) {
            // Since we're trying to protect the entire page, if they
            // refuse to login, we need to navigate to another page
            confirmAuth({ redirectToHomeOnCancel: true });
        }
    }, []);

    if (!isLoggedIn) {
        return <LoadingSpinner />;
    }

    return <Component {...props} />;
};

ProtectedRoute.propTypes = {
    component: PropTypes.elementType.isRequired
};

export default ProtectedRoute;
